import { render, staticRenderFns } from "./stuDorm.vue?vue&type=template&id=558f919e&scoped=true"
import script from "./stuDorm.vue?vue&type=script&lang=js"
export * from "./stuDorm.vue?vue&type=script&lang=js"
import style0 from "./stuDorm.vue?vue&type=style&index=0&id=558f919e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558f919e",
  null
  
)

export default component.exports